import React, { useEffect, useState, useRef } from "react";
import api from "../../api/api";
import "../../css/Employee.css";

const ArchieveEmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [employeesPerPage, setEmployeesPerPage] = useState(10);
  const [showListFilter, setShowListFilter] = useState(false);
  const listFilterRef = useRef(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("all");

  useEffect(() => {
    api
      .get("/inactive/employee/list")
      .then((response) => {
        if (response.data.success) {
          setEmployees(response.data.data);
          setFilteredEmployees(response.data.data);
        }
      })
      .catch((error) => console.error("Error fetching employees:", error))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    api
      .get("/get/company")
      .then((response) => {
        if (response.data.success) {
          setCompanies(response.data.data); // Assuming response.data.data is array of companies
        }
      })
      .catch((error) => {
        console.error("Error fetching companies:", error);
      });
  }, []);

  useEffect(() => {
    let filtered = employees;
    if (selectedCompany !== "all") {
      filtered = filtered.filter((emp) => emp.company_name === selectedCompany);
    }

    filtered = filtered.filter(
      (emp) =>
        `${emp.firstname || ""} ${emp.lastname || ""}`
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (emp.username || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (emp.email || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (emp.phone || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (emp.company_name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (emp.department_name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (emp.designation_name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (emp.state || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredEmployees(filtered);
    setCurrentPage(1);
  }, [searchTerm, employees, selectedCompany]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        listFilterRef.current &&
        !listFilterRef.current.contains(event.target)
      ) {
        setShowListFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePerPageChange = (value) => {
    setEmployeesPerPage(value);
    setShowListFilter(false);
    setCurrentPage(1);
  };

  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  const currentEmployees = filteredEmployees.slice(
    indexOfFirstEmployee,
    indexOfLastEmployee
  );
  const totalPages = Math.ceil(filteredEmployees.length / employeesPerPage);

  // ✅ Toggle active/inactive
  const handleActivate = (emp) => {
    const confirmMsg = `Activate ${emp.firstname} ${emp.lastname}?`;

    if (window.confirm(confirmMsg)) {
      api
        .post("/change/status", { userId: emp.emp_id }) // 🔁 Changed emp_id to userId
        .then((response) => {
          if (response.status === 200 && response.data.message) {
            alert(response.data.message);
            // Remove activated employee from the current list
            const updatedEmployees = employees.filter(
              (e) => e.emp_id !== emp.emp_id
            );
            setEmployees(updatedEmployees);
            setFilteredEmployees(updatedEmployees);
          } else {
            alert("Action failed. Try again.");
          }
        })
        .catch((error) => {
          console.error("Error activating employee:", error);
          alert("An error occurred.");
        });
    }
  };

  return (
    <section className="employee-section">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>Employee List</h2>
          <div className="right-filter">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="select-company tooltip-wrapper" data-tooltip="Filter by Company">
              <select
                value={selectedCompany}
                onChange={(e) => setSelectedCompany(e.target.value)}
              >
                <option value="all">All Companies</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.name}>
                    {company.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="list-fliter tooltip-wrapper" ref={listFilterRef} data-tooltip="Filter by List">
              <button onClick={() => setShowListFilter(!showListFilter)}>
                <i className="fa-solid fa-filter"></i>
              </button>
              {showListFilter && (
                <div className="filter-data">
                  {[10, 30, 50, 100].map((number) => (
                    <div
                      key={number}
                      className={`filter-option ${
                        employeesPerPage === number ? "selected" : ""
                      }`}
                      onClick={() => handlePerPageChange(number)}
                    >
                      {number}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="employee-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Full Name</th>
                    <th>Phone</th>
                    <th>Company</th>
                    <th>Department</th>
                    <th>Designation</th>
                    <th>State</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentEmployees.map((emp, index) => (
                    <tr key={emp.emp_id}>
                      <td>{indexOfFirstEmployee + index + 1}</td>
                      <td>
                        {emp.firstname} {emp.lastname}
                      </td>
                      <td className="phone"><i class="fa-solid fa-phone"></i>&nbsp; {emp.phone}</td>
                      <td className="p-day">{emp.company_name}</td>
                      <td>{emp.department_name}</td>
                      <td>{emp.designation_name}</td>
                      <td>{emp.state}</td>
                      
                      <td
                        style={{
                          color:
                          emp.emp_status === "Inactive"
                              ? "#f64b34"
                              : undefined,
                          fontWeight: "bold",
                        }}
                      >
                        <span className="status">{emp.emp_status || "-"}</span>
                      </td>
                      <td>
                        <div className="auction-btns">
                          <button
                            onClick={() => handleActivate(emp)}
                            className="action-btn activate"
                            title="Activate"
                          >
                            <i className="fa-solid fa-toggle-on"></i> &nbsp;
                            Activate
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="pagination">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default ArchieveEmployeeList;
